import React from 'react';
import Slider from 'react-slick';
import { Icon } from '@iconify/react';
import { s3url } from './../../Admin/Utils';

const ProjectReraQrImage = ({ reraImageArray, reraId, projectName }) => {
    const hasMultipleSlides = reraImageArray.length > 1;
    const Qrsettings = {
        dots: hasMultipleSlides,
        arrows: false,
        infinite: hasMultipleSlides,
        speed: 800,
        slidesToShow: 1,
        slidesToScroll: 1,
        variableWidth: false,
        centerMode: false,
        fade: false,
        autoplay: hasMultipleSlides,
        vertical: false,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    vertical: false,
                    rows: 3,
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    };


    return(
        // console.log(reraImageArray)

        // <div className='rera-qr-wrapper'> 
        //     {
        //         reraImageArray.map((item, index) => (
        //             <div key={index} className='rera-qr-image'>
        //                 <img src={`${s3url}/project-assets${item.url}`} alt={item.alt} />
        //                 <p><b>{reraId}</b></p>
        //                 <p>{projectName}</p>
        //                 <p><a href='https://maharera.maharashtra.gov.in/'>https://maharera.maharashtra.gov.in/</a></p>
        //             </div>
                    
        //         ))
        //     }
        // </div>
        

        hasMultipleSlides ? (
            <Slider {...Qrsettings}>
                {reraImageArray.map((item, index) => (
                    <div key={index} className='rera-qr-image'>
                        <img src={`${s3url}/project-assets${item.url}`} alt={item.alt} />
                        <p><b>{reraId}</b></p>
                        <p>{projectName}</p>
                        <p><a target='_blank' href='https://maharera.maharashtra.gov.in/'>MahaRERA</a></p>
                    </div>
                ))}
            </Slider>
        ) : (
            <div className='rera-qr-wrapper'> 
                {
                    reraImageArray.map((item, index) => (
                        <div key={index} className='rera-qr-image'>
                            <img src={`${s3url}/project-assets${item.url}`} alt={item.alt} />
                            <p><b>{reraId}</b></p>
                            <p className='prname'>{projectName}</p>
                            <p><a target='_blank' href='https://maharera.maharashtra.gov.in/'>MahaRERA</a></p>
                        </div>
                        
                    ))
                }
            </div>
        )
           
    );

}

export default ProjectReraQrImage;